module.exports = __webpack_public_path__ + "static/item-5-68ad10f1a59f00591db8d80831c67e59.jpeg";